// import { getCurrentEmailsFromLocalStorage, setCurrentEmailsInLocalStorage } from "helpers/sf_utils"
import {
  GET_CALL_PRICES,
  GET_CALL_PRICES_SUCCESS,
  GET_CALL_PRICES_ERROR,

} from "./actionTypes"

const INIT_STATE = {
  call_prices: [],
  error: null,
  loading: false,
}
const CallPrices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CALL_PRICES:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_CALL_PRICES_SUCCESS:
      return {
        ...state,
        error: null,
        call_prices: action.payload,
        loading: false,

      }

    case GET_CALL_PRICES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,

      }

    default:
      return state
  }
}

export default CallPrices
